class Collection {
  constructor() {
    this.bindInit();
  }
  bindInit() {
    this.perRowProduct();
  }


  perRowProduct() {
    const perRowTwoProduct = document.querySelector('.js-per-row-two');
    const perRowThreeProduct = document.querySelector('.js-per-row-three');
    const productContainer = document.querySelector('.js-collection-grid');

    perRowTwoProduct.addEventListener('click', () => {
        perRowTwoProduct.classList.add('is-active');
        perRowThreeProduct.classList.remove('is-active');
        productContainer.classList.remove('collection_grid_per-row-3');
        productContainer.classList.remove('collection_grid_per-row-4');
        productContainer.classList.remove('collection_grid_per-row-5');
    });

    perRowThreeProduct.addEventListener('click', () => {
      perRowTwoProduct.classList.remove('is-active');
      perRowThreeProduct.classList.add('is-active');
      productContainer.classList.add('collection_grid_per-row-3');
      productContainer.classList.remove('collection_grid_per-row-4');
      productContainer.classList.remove('collection_grid_per-row-5');
    });
  }
}

new Collection();
